import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

// Order matters:
//   1. Full vanilla Bootstrap from npm — provides every utility class and
//      component. Loaded from the JS bundle (after the AFB CDN <link> in
//      index.html), so anything the AFB theme is missing gets backfilled
//      here, and where they overlap, this wins.
//   2. AFB CDN theme stays in index.html as a fallback baseline (loads
//      before this bundle so it ships partial styling immediately, then
//      this overrides it).
//   3. Our local overrides last.
import "bootstrap/dist/css/bootstrap.min.css";
import "quill/dist/quill.snow.css";
import "./styles/overrides.scss";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
